module.exports = __webpack_public_path__ + "static/kastanjalogo-74a7559f1e042a9072484bee5b483cb8.jpg";